import React from 'react';
import './App.css';
import NavBar from '../components/Navigation/NavBar/NavBar'

const App = () => {
   
  return (
    <>
     <NavBar />
    </>
  );
}

export default App
